import React from 'react';
import { Stack, Typography } from '@mui/material';
import { getColor } from '../../helpers/getColor';
import { palette } from '../../styles/theme';

export function WidgetClientData ({ title, value, border = true, altBorder, position, icon, valueColor = palette.primary.main }) {
    const borderColor = altBorder ? getColor('yellow', 400, 0.5) : getColor('primary', 800);
    return (
        <Stack direction={position !== undefined ? position : 'column'} alignItems={'center'} justifyContent={'center'} paddingRight={'18px'} paddingLeft={position !== undefined ? '0px' : '12px'} gap='8px' borderRight={border ? 'solid 1px' : 'none'} borderColor={borderColor}>
            <Stack direction='inline-flex' alignItems='center' justifyContent='center' gap={'0.5rem'}>
                <Typography fontSize={position !== undefined ? '16px' : '12px'} variant='h3'>{title}</Typography>
                {icon && icon}
            </Stack>
            <Typography variant='h4' color={valueColor}>{value}</Typography>
        </Stack>
    );
}
